import React from "react";
import ProductRail from "web/react/components/product-rail/product-rail";
import styles from "./homepage-product-rail.css";
export function HomepageProductRail(_ref) {
  var title = _ref.title,
      products = _ref.products;
  return React.createElement(ProductRail, {
    className: styles.homepageRail,
    title: title,
    label: "homepage-popular-products",
    products: products,
    type: "homepage",
    features: {},
    railClassName: styles.homepageRailList,
    id: "product-rail",
    imageSize: "feed"
  });
}
export default HomepageProductRail;